<template>
  <div class="inspection-items-form">
    <el-divider content-position="center">检验报告附页 - 检验项目</el-divider>
    <el-form :model="formData" label-width="140px">
      <el-divider content-position="left">1. 车辆的认定</el-divider>
      <inspection-section
        v-model="formData.vehicle_identification"
        title=""
      />
      <el-divider content-position="left">2. 驾驶室</el-divider>
      <inspection-section
        v-model="formData.cab_inspection"
        title=""
      />
      <el-divider content-position="left">3. 发动机</el-divider>
      <inspection-section
        v-model="formData.engine_inspection"
        title=""
      />
      <el-divider content-position="left">4. 传动系统</el-divider>
      <inspection-section
        v-model="formData.transmission_inspection"
        title=""
      />
      <el-divider content-position="left">5. 行驶系统</el-divider>
      <inspection-section
        v-model="formData.driving_system_inspection"
        title=""
      />
      <el-divider content-position="left">6. 仪表</el-divider>
      <inspection-section
        v-model="formData.instrument_inspection"
        title=""
      />
      <el-divider content-position="left">7. 电气</el-divider>
      <inspection-section
        v-model="formData.electrical_inspection"
        title=""
      />
      <el-divider content-position="left">8. 液压系统</el-divider>
      <inspection-section
        v-model="formData.hydraulic_system_inspection"
        title=""
      />
    </el-form>
  </div>
</template>

<script>
import InspectionSection from './InspectionSection.vue'

export default {
  name: 'InspectionItemsForm',
  components: {
    InspectionSection
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        vehicle_identification: {
          items: [
            { code: '1.1', requirement: '车辆应具有出厂合格证书及有关技术资料', result: '', judgment: '' },
            { code: '1.2', requirement: '车辆易见部位上应有产品的商标或厂标', result: '', judgment: '' },
            { code: '1.3', requirement: '车辆应在产品标牌上标明产品名称、型号、制造日期或产品编号、制造商名称及制造国', result: '', judgment: '' },
            { code: '1.4', requirement: '车辆的发动机、底盘易见部位应具有永久清晰字样的编号', result: '', judgment: '' }
          ],
          judgment: ''
        },
        cab_inspection: {
          items: [
            { code: '2.1', requirement: '装有封闭式驾驶室的车辆，驾驶室应装有门锁，且完好有效', result: '', judgment: '' },
            { code: '2.2', requirement: '封闭式驾驶室内应通风良好，装设的取暖、风挡除霜和遮阳装置应完好有效', result: '', judgment: '' },
            { code: '2.3', requirement: '驾驶员座椅应保证其舒适、牢靠，前后可调整', result: '', judgment: '' },
            { code: '2.4', requirement: '驾驶室应保持视线良好，视野开阔', result: '', judgment: '' },
            { code: '2.5', requirement: '前风挡玻璃应采用符合 GB 9656 规定的安全玻璃', result: '', judgment: '' },
            { code: '2.6', requirement: '前风挡玻璃装置的刮水器应完好有效，应确保驾驶员有良好的前方视野', result: '', judgment: '' },
            { code: '2.7', requirement: '配有灭火器的车辆，应保证其灭火器在有效期内，且功能有效', result: '', judgment: '' }
          ],
          judgment: ''
        },
        engine_inspection: {
          items: [
            { code: '3.1', requirement: '发动机应能正常启动、熄火，运转平稳，怠速稳定，机油压力正常', result: '', judgment: '' },
            { code: '3.2', requirement: '发动机的安装应牢固可靠，连接部分无松动、脱落、损坏', result: '', judgment: '' },
            { code: '3.3', requirement: '点火系统、燃料系统、润滑系统、冷却系统的机件应齐全，性能良好，安装牢固，线路无漏电现象，管路无渗漏', result: '', judgment: '' }
          ],
          judgment: ''
        },
        transmission_inspection: {
          items: [
            { code: '4.1', requirement: '离合器分离彻底，结合平稳，不打滑、无异响', result: '', judgment: '' },
            { code: '4.2', requirement: '离合器踏板的自由行程应符合该车整车技术条件的规定', result: '', judgment: '' },
            { code: '4.3', requirement: '离合器踏板分离时，踏板力不应大于 300 N，手握力不应大于 200 N', result: '', judgment: '' },
            { code: '4.4', requirement: '变速器变速杆的位置适当，自锁、互锁可靠，不应有乱档和自动跳档现象；变速器、分动器应不漏无异响', result: '', judgment: '' },
            { code: '4.5', requirement: '万向节、传动轴、中间轴承、传动链条应运转平稳，螺栓齐全，紧固牢靠，运行中不应发生振抖和异响', result: '', judgment: '' },
            { code: '4.6', requirement: '驱动桥壳、桥管不允许有变形和裂纹，驱动桥工作应正常且不应有异响；半轴螺栓齐全紧固', result: '', judgment: '' },
            { code: '4.7', requirement: '油门踏板释放后，应保证其能自动复位', result: '', judgment: '' }
          ],
          judgment: ''
        },
        driving_system_inspection: {
          items: [
            { code: '5.1', requirement: '车架无变形、裂纹、锈蚀，螺栓铆钉无缺损松动', result: '', judgment: '' },
            { code: '5.2', requirement: '钢板弹簧、卡子、螺栓紧固，与桥及车架连接紧固', result: '', judgment: '' },
            { code: '5.3', requirement: '前后桥无变形和裂纹', result: '', judgment: '' },
            { code: '5.4', requirement: '同一车桥装用同一型号轮胎', result: '', judgment: '' },
            { code: '5.5', requirement: '充气轮胎气压和负荷不大于规定值', result: '', judgment: '' },
            { code: '5.6', requirement: '充气轮胎磨损花纹深度≥3.2mm，胎面/胎壁无超过25mm的长裂纹或露出帘布层', result: '', judgment: '' },
            { code: '5.7', requirement: '轮辋完好，螺栓螺母齐全紧固', result: '', judgment: '' },
            { code: '5.8', requirement: '履带部件完整、运转正常、无裂纹变形', result: '', judgment: '' },
            { code: '5.9', requirement: '履带每10节直线度误差≤4mm，全长误差≤8mm', result: '', judgment: '' }
          ],
          judgment: ''
        },
        instrument_inspection: {
          items: [
            { code: '6.1', requirement: '各种仪表（气压、机油压、水温、燃油量、电压等）设置齐全、灵敏、有效', result: '', judgment: '' }
          ],
          judgment: ''
        },
        electrical_inspection: {
          items: [
            { code: '7.1', requirement: '喇叭声级在 90 dB (A) ~ 115 dB (A) 范围内', result: '', judgment: '' },
            { code: '7.2', requirement: '电器导线布置合理、固定、接头牢固、绝缘套完好', result: '', judgment: '' },
            { code: '7.3', requirement: '蓄电池极柱连接牢固可靠、无锈蚀、涂抹防锈脂', result: '', judgment: '' },
            { code: '7.4', requirement: '电解液面高出极板 10mm~15mm，加液孔盖齐全、通气孔畅通', result: '', judgment: '' },
            { code: '7.5', requirement: '蓄电池金属盖板与带电部分间隙>30mm；若有绝缘层则间隙≥10mm', result: '', judgment: '' },
            { code: '7.6', requirement: '电动机运转平稳无异响、温升正常、防护罩齐全', result: '', judgment: '' },
            { code: '7.7', requirement: '电动机悬挂及各处连接牢固可靠', result: '', judgment: '' },
            { code: '7.8', requirement: '蓄电池车的紧急断电装置为机械式且易于操作', result: '', judgment: '' },
            { code: '7.9', requirement: '换向开关、制动联锁、零位保护、过电流保护装置有效', result: '', judgment: '' }
          ],
          judgment: ''
        },
        hydraulic_system_inspection: {
          items: [
            { code: '8.1', requirement: '管路布置不与运动部件干涉', result: '', judgment: '' },
            { code: '8.2', requirement: '密封性能良好，作业时无渗油，运动接口无漏油', result: '', judgment: '' },
            { code: '8.3', requirement: '在空载和满载情况下，液压元件均能正常工作', result: '', judgment: '' },
            { code: '8.4', requirement: '设置滤油器和防尘装置，加油口有滤网', result: '', judgment: '' }
          ],
          judgment: ''
        }
      })
    }
  },
  computed: {
    formData: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.inspection-items-form {
  margin-top: 20px;
}
</style>
